import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { apiClient } from '@/api/client';
import { API_USER } from '@/api/endpoints';
import { USER_QUERY_KEY } from '@/api/queryKeys';
import type { UserInfoResponse } from '@/types/user';
import { unwrapAxiosResponse } from '@/utils/axios';
import { ErrorMessage, logRequestError } from '@/utils/errors';

export const useRefreshUser = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    try {
      const user = await apiClient
        .get<UserInfoResponse>(API_USER)
        .then(unwrapAxiosResponse);

      queryClient.setQueryData(USER_QUERY_KEY, user);
    } catch (error) {
      logRequestError(ErrorMessage.RefreshUser, error);
    }
  }, [queryClient]);
};
